export default "/images/667666530b06d44f2a0081439bb2fc04.avif";